import type { SummaryStatistics } from '../models/simulation';

const toSortedArray = (samples: Float64Array): number[] => {
    const sorted = Array.from(samples);
    sorted.sort((a, b) => a - b);
    return sorted;
};

const quantileSorted = (sorted: number[], p: number): number => {
    if (sorted.length === 0) {
        return 0;
    }
    const position = (sorted.length - 1) * p;
    const lower = Math.floor(position);
    const upper = Math.ceil(position);
    if (lower === upper) {
        return sorted[lower];
    }
    const weight = position - lower;
    return sorted[lower] * (1 - weight) + sorted[upper] * weight;
};

const mean = (samples: Float64Array): number => {
    if (samples.length === 0) {
        return 0;
    }
    let total = 0;
    for (let i = 0; i < samples.length; i += 1) {
        total += samples[i];
    }
    return total / samples.length;
};

const variance = (samples: Float64Array, mu: number): number => {
    if (samples.length < 2) {
        return 0;
    }
    let total = 0;
    for (let i = 0; i < samples.length; i += 1) {
        const diff = samples[i] - mu;
        total += diff * diff;
    }
    return total / (samples.length - 1);
};

export const summarizeSamples = (samples: Float64Array): SummaryStatistics => {
    const mu = mean(samples);
    const sorted = toSortedArray(samples);
    return {
        mean: mu,
        median: quantileSorted(sorted, 0.5),
        p10: quantileSorted(sorted, 0.1),
        p90: quantileSorted(sorted, 0.9),
        std: Math.sqrt(variance(samples, mu))
    };
};
